/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const scheduleCreateBodyTimeZoneDefault = `Europe/Amsterdam`;
export const scheduleCreateBodyTimeZoneMax = 100;

export const scheduleCreateBodyRoutinesItemStartLocalDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const scheduleCreateBodyRoutinesItemAnchorClockLocalRegExp = new RegExp(
  '^(?:[01]\\d|2[0-3]):[0-5]\\d$',
);
export const scheduleCreateBodyRoutinesItemRotationCountExclusiveMin = 0;
export const scheduleCreateBodyRoutinesItemRotationCountMax = 2147483647;

export const scheduleCreateBodyRoutinesItemSectionsItemStartWeekdayMax = 7;

export const scheduleCreateBodyRoutinesItemSectionsItemStartLocalMinuteMin = 0;
export const scheduleCreateBodyRoutinesItemSectionsItemStartLocalMinuteMax = 1439;

export const scheduleCreateBodyRoutinesItemSectionsItemEndWeekdayMax = 7;

export const scheduleCreateBodyRoutinesItemSectionsItemEndLocalMinuteMin = 0;
export const scheduleCreateBodyRoutinesItemSectionsItemEndLocalMinuteMax = 1439;

export const scheduleCreateBodyRoutinesItemSectionsItemFullWeekDefault = false;
export const scheduleCreateBodyRoutinesItemSectionsMax = 14;

export const scheduleCreateBodyRoutinesItemParticipantsItemOrdinalMin = 0;
export const scheduleCreateBodyRoutinesItemParticipantsItemOrdinalMax = 19;

export const scheduleCreateBodyRoutinesItemParticipantsItemUserIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const scheduleCreateBodyRoutinesItemParticipantsMax = 20;

export const scheduleCreateBodyRoutinesItemEndedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const scheduleCreateBodyRoutinesMax = 10;

export const ScheduleCreateBody = zod.object({
  teamId: zod.unknown().optional(),
  scheduleId: zod.unknown().optional(),
  name: zod.string(),
  timeZone: zod
    .string()
    .min(1)
    .max(scheduleCreateBodyTimeZoneMax)
    .default(scheduleCreateBodyTimeZoneDefault),
  routines: zod
    .array(
      zod.object({
        name: zod.string(),
        startLocalDate: zod.iso.date().regex(scheduleCreateBodyRoutinesItemStartLocalDateRegExp),
        anchorClockLocal: zod.string().regex(scheduleCreateBodyRoutinesItemAnchorClockLocalRegExp),
        rotation: zod.object({
          unit: zod.enum(['day', 'week']),
          count: zod
            .int()
            .gt(scheduleCreateBodyRoutinesItemRotationCountExclusiveMin)
            .max(scheduleCreateBodyRoutinesItemRotationCountMax),
        }),
        sections: zod
          .array(
            zod.object({
              startWeekday: zod
                .int()
                .min(1)
                .max(scheduleCreateBodyRoutinesItemSectionsItemStartWeekdayMax),
              startLocalMinute: zod
                .int()
                .min(scheduleCreateBodyRoutinesItemSectionsItemStartLocalMinuteMin)
                .max(scheduleCreateBodyRoutinesItemSectionsItemStartLocalMinuteMax),
              endWeekday: zod
                .int()
                .min(1)
                .max(scheduleCreateBodyRoutinesItemSectionsItemEndWeekdayMax),
              endLocalMinute: zod
                .int()
                .min(scheduleCreateBodyRoutinesItemSectionsItemEndLocalMinuteMin)
                .max(scheduleCreateBodyRoutinesItemSectionsItemEndLocalMinuteMax),
              fullWeek: zod
                .boolean()
                .default(scheduleCreateBodyRoutinesItemSectionsItemFullWeekDefault),
            }),
          )
          .min(1)
          .max(scheduleCreateBodyRoutinesItemSectionsMax),
        participants: zod
          .array(
            zod.object({
              ordinal: zod
                .int()
                .min(scheduleCreateBodyRoutinesItemParticipantsItemOrdinalMin)
                .max(scheduleCreateBodyRoutinesItemParticipantsItemOrdinalMax),
              userId: zod.uuid().regex(scheduleCreateBodyRoutinesItemParticipantsItemUserIdRegExp),
            }),
          )
          .min(1)
          .max(scheduleCreateBodyRoutinesItemParticipantsMax),
        endedAt: zod
          .union([
            zod.iso
              .datetime({ offset: true })
              .regex(scheduleCreateBodyRoutinesItemEndedAtOneRegExp),
            zod.null(),
          ])
          .optional(),
      }),
    )
    .max(scheduleCreateBodyRoutinesMax)
    .optional(),
});

export type ScheduleCreateBody = zod.input<typeof ScheduleCreateBody>;
export type ScheduleCreateBodyOutput = zod.output<typeof ScheduleCreateBody>;
